import {Action} from '@ngrx/store';
import {type} from '../utilities/type';
import {ArrayResponse} from '..';

export const myCompaniesLinkContractActionTypes = {
  LOAD: type('[Companies Link Contract] Load'),
  LOAD_SUCCESS: type('[Companies Link Contract] Load Success'),
  LOAD_FAIL: type('[Companies Link Contract] Load Fail')
};

export class LoadMyCompaniesLinkContractAction implements Action {
  readonly type = myCompaniesLinkContractActionTypes.LOAD;
  constructor(public payload?: { typeaheadQuery?: string}) {}
}

export class LoadMyCompaniesLinkContractSuccessAction implements Action {
  readonly type = myCompaniesLinkContractActionTypes.LOAD_SUCCESS;
  // tslint:disable-next-line:no-any
  constructor(public payload?:  ArrayResponse<any>) {}
}

export class LoadMyCompaniesLinkContractFailAction implements Action {
  readonly type = myCompaniesLinkContractActionTypes.LOAD_FAIL;
  constructor(public payload?: string) {}
}
